import React from 'react';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import DetailItem from './DetailItem';

export default function DetailsPanel(props) {
    const nodesGroupedByStation = groupBy(props.bagTimeLine, 'stationCode');

    return (
        <div className="bag-details-list">
            {map(nodesGroupedByStation, (stationNodes, stationCode) => (
                <DetailItem
                    key={stationCode}
                    onStationClick={props.onStationClick}
                    stationCode={stationCode}
                    selectedStationCode={props.selectedStationCode}
                    stationNodes={stationNodes}
                    urlData={props.urlData}
                />
            ))}
        </div>
    );
}

DetailsPanel.propTypes = {
    selectedStationCode: PropTypes.string.isRequired,
    bagTimeLine: PropTypes.instanceOf(Array),
    urlData: PropTypes.instanceOf(Object),
};
